import React from 'react';
//import $ from 'jquery';
import { Link } from 'react-router-dom';
import { BsArrowRight } from "react-icons/bs";
import Img1 from '../../images/Concept Drawings & Renderings/242 Park - Concept Drawing 2(1).jpg';
import Img2 from '../../images/Concept Drawings & Renderings/242 Park - Concept Drawing 2.jpg';
import Img3 from '../../images/Concept Drawings & Renderings/242 Park - Concept Drawing 3.jpg';
import Img4 from '../../images/Concept Drawings & Renderings/242 Park - Concept Drawing 4.jpg';
import Img5 from '../../images/Concept Drawings & Renderings/242 Park - Exterior Draft 1.jpg';
import Img6 from '../../images/Concept Drawings & Renderings/242 Park - Exterior Draft 2.jpg';
import Img7 from '../../images/Concept Drawings & Renderings/242 Park - Exterior Draft 3.jpg';
import Img8 from '../../images/Concept Drawings & Renderings/242 Park - Exterior Draft 4.jpg';
import Img9 from '../../images/Concept Drawings & Renderings/242 Park - Exterior Site 1.jpg';
import Img10 from '../../images/Concept Drawings & Renderings/242 Park - Sign Posting 1.jpeg';
import Img11 from '../../images/Concept Drawings & Renderings/242 Park - Sign Posting 2.jpeg';


export default () => (

	<div className='project-template'>
		<img className='main-project-img' src={Img1} ></img>

		<h4>The Carillon Project</h4>
		<h5>8 Unit Development</h5>
		<p>Introducing our 3 storey residential building, boasting 8 thoughtfully designed one-bedroom units. Located across from a park in a peaceful neighborhood and within walking distance to essential amenities, this property offers an exceptional living experience. With a dedicated bike rack, the building caters to environmentally conscious residents.</p>
		<div className='project-desc-text-2' >
			<p class="p1">COMING 2026 · OTTAWA,ON · 8 UNITS · 3 STOREY DEVELOPMENT - ESTIMATED AT 500 TO 600 SQ FT PER UNIT
			</p>
		</div>
		<Link className="proj-button" to='/contactpage'>
			<button className="projectpage-button">GET IN TOUCH</button>
		</Link>


		<div className="project-split">

			<img className="project-img" src={Img11}></img>
			<img className="project-img" src={Img10}></img>
			<img className="project-img" src={Img9}></img>
			<img className="project-img" src={Img8}></img>
			<img className="project-img" src={Img7} ></img>
			<img className="project-img" src={Img6}></img>
			<img className="project-img" src={Img5}></img>
			<img className="project-img" src={Img4}></img>
			<img className="project-img" src={Img3}></img>
			<img className="project-img" src={Img2}></img>

		</div>


	</div>


);
